var map = {
	"./Husappen-liggande.png": 6257,
	"./Ikoner/cat_agare.png": 8479,
	"./Ikoner/cat_all.png": 5440,
	"./Ikoner/cat_all_bw.png": 3876,
	"./Ikoner/cat_appliances.png": 2845,
	"./Ikoner/cat_appliances_bw.png": 371,
	"./Ikoner/cat_avtal.png": 1745,
	"./Ikoner/cat_avtal_bw.png": 8223,
	"./Ikoner/cat_electronics.png": 7632,
	"./Ikoner/cat_electronics_bw.png": 9732,
	"./Ikoner/cat_forbattringar.png": 2480,
	"./Ikoner/cat_forbattringar_bw.png": 9636,
	"./Ikoner/cat_garden.png": 9102,
	"./Ikoner/cat_garden_bw.png": 6410,
	"./Ikoner/cat_inredning.png": 8693,
	"./Ikoner/cat_inredning_bw.png": 1531,
	"./Ikoner/cat_intyg.png": 9498,
	"./Ikoner/cat_intyg_bw.png": 5182,
	"./Ikoner/cat_manualer.png": 2402,
	"./Ikoner/cat_manualer_bw.png": 9462,
	"./Ikoner/cat_materials.png": 6247,
	"./Ikoner/cat_materials_bw.png": 4061,
	"./Ikoner/cat_placeholder.png": 5622,
	"./Ikoner/cat_placeholder_bw.png": 4578,
	"./Ikoner/cat_renovering.png": 494,
	"./Ikoner/cat_renovering_bw.png": 7306,
	"./Ikoner/cat_ritningar.png": 7387,
	"./Ikoner/cat_ritningar_bw.png": 6585,
	"./Ikoner/cat_services.png": 1937,
	"./Ikoner/cat_services_bw.png": 9455,
	"./Ikoner/cat_tools.png": 6788,
	"./Ikoner/cat_tools_bw.png": 4560,
	"./Meny-ikoner/ikon_analys.png": 5354,
	"./Meny-ikoner/ikon_byggnader.png": 3633,
	"./Meny-ikoner/ikon_ekonomi.png": 9978,
	"./Meny-ikoner/ikon_forvaltning.png": 7022,
	"./Meny-ikoner/ikon_projekt.png": 6629,
	"./Meny-ikoner/ikon_tidslinje.png": 3378,
	"./archipelago_toilet_placeholder.png": 9240,
	"./button-icons/button_contacts.png": 9635,
	"./button-icons/button_files.png": 9091,
	"./button-icons/button_images.png": 1178,
	"./button-icons/button_stamp.png": 3711,
	"./button-icons/up_right_arrow.png": 1601,
	"./chevron-right.png": 7587,
	"./close.png": 2943,
	"./compass.png": 7827,
	"./drift_kugghjul.png": 8776,
	"./house_placeholder.png": 7881,
	"./logo_liggande.png": 9144,
	"./logo_white.png": 9708,
	"./maintenance.png": 2118,
	"./map/blue_marker.png": 6661,
	"./map/grey_marker.png": 2674,
	"./map/red_marker.png": 7596,
	"./materials/acoustic_tiles.png": 449,
	"./materials/aluminum.png": 8324,
	"./materials/asbestos_cement.png": 7391,
	"./materials/brick.png": 1919,
	"./materials/cement_board.png": 9151,
	"./materials/ceramic_tiles.png": 962,
	"./materials/composite.png": 9585,
	"./materials/concrete.png": 8123,
	"./materials/concrete_cast_in_place.png": 2783,
	"./materials/concrete_painted.png": 5045,
	"./materials/concrete_precast.png": 3428,
	"./materials/corrugated_metal.png": 6232,
	"./materials/drop_tiles.png": 1387,
	"./materials/drywall.png": 5067,
	"./materials/drywall_painted.png": 1157,
	"./materials/drywall_wallpaper.png": 3088,
	"./materials/fiber_cement.png": 5667,
	"./materials/floor_carpet.png": 938,
	"./materials/floor_laminate.png": 9402,
	"./materials/floor_parquet.png": 107,
	"./materials/floor_tiles.png": 8796,
	"./materials/floor_vinyl.png": 7931,
	"./materials/granite.png": 5910,
	"./materials/grass.png": 9654,
	"./materials/gravel.png": 2279,
	"./materials/leca.png": 6451,
	"./materials/lightweight_concrete.png": 4304,
	"./materials/metal.png": 8073,
	"./materials/metal_works_on_facade.png": 9007,
	"./materials/organic_material.png": 4383,
	"./materials/plastic.png": 20,
	"./materials/plywood.png": 7458,
	"./materials/pvc.png": 6837,
	"./materials/render.png": 6510,
	"./materials/render_painted.png": 8236,
	"./materials/render_thick.png": 628,
	"./materials/render_thin.png": 338,
	"./materials/rolled_sheet_metal.png": 9120,
	"./materials/roofing_felt.png": 9704,
	"./materials/sedum.png": 4946,
	"./materials/sheet_metal.png": 3921,
	"./materials/soil_layer.png": 5713,
	"./materials/steel.png": 949,
	"./materials/steel_decking.png": 8737,
	"./materials/stone.png": 4235,
	"./materials/structural_timber.png": 3333,
	"./materials/tile_roof.png": 7681,
	"./materials/wood.png": 4509,
	"./materials/wood_glulam.png": 474,
	"./materials/wood_panel_bare.png": 1659,
	"./materials/wood_panel_painted.png": 1172,
	"./materials/wood_prefab.png": 1904,
	"./no_reception.png": 580,
	"./projects.png": 5837,
	"./red_pin.png": 7678,
	"./rooms/room_assembly.png": 8346,
	"./rooms/room_bathroom.png": 3020,
	"./rooms/room_changing.png": 647,
	"./rooms/room_cold_attic.png": 3840,
	"./rooms/room_conference.png": 6192,
	"./rooms/room_entryway.png": 5507,
	"./rooms/room_exhibit.png": 3347,
	"./rooms/room_general.png": 3260,
	"./rooms/room_hallway.png": 3426,
	"./rooms/room_kitchen.png": 9952,
	"./rooms/room_lecture.png": 1406,
	"./rooms/room_office.png": 5298,
	"./rooms/room_storage.png": 2327,
	"./rooms/room_utility.png": 6972,
	"./rooms/room_warm_attic.png": 7473,
	"./rooms/room_work.png": 4029,
	"./timeline.png": 7362,
	"./types/chimney.png": 2360,
	"./types/chimney_cap.png": 2021,
	"./types/chimney_flue.png": 9433,
	"./types/chimney_stack.png": 9885,
	"./types/door_automation.png": 6431,
	"./types/drainage.png": 2234,
	"./types/drainage_drainpipe.png": 5141,
	"./types/drainage_gutter.png": 3642,
	"./types/electrical.png": 3419,
	"./types/elevator.png": 4771,
	"./types/facade.png": 1079,
	"./types/facade_cavity_wall.png": 6543,
	"./types/facade_corrugated_metal.png": 1478,
	"./types/facade_horizontal_siding.png": 5161,
	"./types/facade_plinth.png": 8429,
	"./types/facade_render.png": 7528,
	"./types/facade_sandwich_panel.png": 5215,
	"./types/facade_thin_render.png": 2222,
	"./types/facade_vertical_siding.png": 7263,
	"./types/fire_safety.png": 4412,
	"./types/foundation.png": 606,
	"./types/foundation_blinding_layer.png": 9678,
	"./types/foundation_cellar.png": 2630,
	"./types/foundation_crawl_space.png": 7037,
	"./types/foundation_ground_slab.png": 6743,
	"./types/foundation_pier.png": 507,
	"./types/foundation_pile.png": 731,
	"./types/foundation_raised_floor.png": 9979,
	"./types/foundation_sloping_site.png": 9017,
	"./types/foundation_wall_on_footing.png": 4226,
	"./types/heating_cooling.png": 8163,
	"./types/hydraulic_elevator.png": 4345,
	"./types/interior_ceiling.png": 941,
	"./types/interior_floor.png": 354,
	"./types/interior_wall.png": 7962,
	"./types/mechanical_maintenance_risk_constructions.png": 6487,
	"./types/outdoor_grass_area.png": 2244,
	"./types/outdoor_other.png": 3874,
	"./types/outdoor_parking_asphalt.png": 5480,
	"./types/outdoor_parking_gravel.png": 7008,
	"./types/outdoor_paved_area.png": 7800,
	"./types/outdoor_paved_area_asphalt.png": 2532,
	"./types/outdoor_paved_area_stone.png": 4910,
	"./types/outdoor_pavement.png": 8848,
	"./types/outdoor_permanent_furniture.png": 7437,
	"./types/outdoor_playground.png": 1537,
	"./types/outdoor_sandbox.png": 8829,
	"./types/outdoor_slide.png": 9123,
	"./types/outdoor_stone_wall.png": 9336,
	"./types/outdoor_swing_set.png": 4403,
	"./types/outdoor_terrace.png": 1950,
	"./types/outdoor_wooden_fence.png": 5342,
	"./types/outdoor_wooden_plank.png": 7029,
	"./types/roof.png": 4307,
	"./types/roof_brick.png": 3621,
	"./types/roof_concrete.png": 5209,
	"./types/roof_corrugated_metal.png": 5642,
	"./types/roof_felt.png": 2799,
	"./types/roof_fiber_cement.png": 6653,
	"./types/roof_rolled_sheet_metal.png": 8246,
	"./types/roof_sedum.png": 4860,
	"./types/roof_shape_cylindrical.png": 4168,
	"./types/roof_shape_flat.png": 8287,
	"./types/roof_shape_gable.png": 8903,
	"./types/roof_shape_hip.png": 2819,
	"./types/roof_shape_inverted_shed.png": 3916,
	"./types/roof_shape_mansard.png": 6126,
	"./types/roof_shape_shed.png": 5816,
	"./types/stairlift.png": 4837,
	"./types/structural_column_in_facade.png": 4472,
	"./types/structural_column_interior_wall.png": 4289,
	"./types/structural_concealed_beam.png": 7099,
	"./types/structural_exposed_beam.png": 1127,
	"./types/structural_roof_beam.png": 9405,
	"./types/structural_roof_truss.png": 1187,
	"./types/structural_solid_wall_exterior.png": 7036,
	"./types/structural_solid_wall_interior.png": 5586,
	"./types/structural_stud_wall_exterior.png": 8667,
	"./types/structural_stud_wall_interior.png": 7741,
	"./types/traction_elevator.png": 7124,
	"./types/utility_air_conditioning.png": 5620,
	"./types/utility_air_to_air_heat_pump.png": 1257,
	"./types/utility_air_to_water_heat_pump.png": 560,
	"./types/utility_district_cooling.png": 9440,
	"./types/utility_electric_boiler.png": 563,
	"./types/utility_electric_main_switchboard.png": 5086,
	"./types/utility_electric_sub_switchboard.png": 8289,
	"./types/utility_f_ventilation.png": 1810,
	"./types/utility_fire_alarm.png": 7756,
	"./types/utility_fire_blanket.png": 3758,
	"./types/utility_fire_control_panel.png": 1015,
	"./types/utility_fire_extinguisher.png": 7478,
	"./types/utility_freight_elevator.png": 7412,
	"./types/utility_ft_ventilation.png": 6816,
	"./types/utility_ftx_ventilation.png": 8542,
	"./types/utility_fx_ventilation.png": 3252,
	"./types/utility_geothermal_heat_pump_bedrock.png": 8907,
	"./types/utility_geothermal_heat_pump_earth.png": 7865,
	"./types/utility_mechanical_dehumidification.png": 9922,
	"./types/utility_passenger_elevator.png": 3571,
	"./types/utility_pellet_boiler.png": 6450,
	"./types/utility_pool_heating.png": 2815,
	"./types/utility_radon_extractor.png": 3803,
	"./types/utility_s_ventilation.png": 1891,
	"./types/utility_safety_guard_system.png": 3712,
	"./types/utility_smoke_detector.png": 5581,
	"./types/utility_sorption_dehumidification.png": 9663,
	"./types/utility_sprinkler.png": 9056,
	"./types/utility_ventilated_floor_unit.png": 7614,
	"./types/utility_wood_boiler.png": 8638,
	"./types/ventilation.png": 9288,
	"./types/water_and_sewage.png": 7899,
	"./types/window_aluminium.png": 839,
	"./types/window_pvc.png": 6677,
	"./types/window_wood.png": 2333
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2536;